export const CAPABILITIES = ['view', 'comment', 'edit', 'share', 'rename', 'delete', 'transfer'] as const
export type Capability = (typeof CAPABILITIES)[number]

export const ROLES = ['viewer', 'editor', 'maintainer', 'admin'] as const
export type Role = (typeof ROLES)[number]

const VIEWER: Capability[] = ['view', 'comment']
const EDITOR: Capability[] = [...VIEWER, 'edit']
const MAINTAINER: Capability[] = [...EDITOR, 'share', 'rename']
const ADMIN: Capability[] = [...MAINTAINER, 'delete', 'transfer']

export const ROLE_CAPABILITIES: Record<Role, Capability[]> = {
  viewer: VIEWER,
  editor: EDITOR,
  maintainer: MAINTAINER,
  admin: ADMIN,
}

export const ALL_CAPABILITIES: Set<Capability> = new Set(CAPABILITIES)

export function capabilitiesFor(role: Role): Set<Capability> {
  return new Set(ROLE_CAPABILITIES[role])
}

export function isRole(x: string): x is Role {
  return (ROLES as readonly string[]).includes(x)
}

/** True when every capability the role grants is already in `caps` (the grant ceiling). */
export function roleWithinCaps(role: Role, caps: Set<Capability>): boolean {
  return ROLE_CAPABILITIES[role].every((c) => caps.has(c))
}
